import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        words: Array,
        period: { type: Number, default: 2000 }
    }

    connect() {
        this.txt = ''
        this.wordIndex = 0
        this.isDeleting = false
        this.type()
    }

    type() {
        const current = this.wordIndex % this.wordsValue.length
        const fullTxt = this.wordsValue[current]

        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1)
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1)
        }

        this.element.innerHTML = this.txt

        let delta = 200 - Math.random() * 100

        if (this.isDeleting) { delta /= 2 }

        if (!this.isDeleting && this.txt === fullTxt) {
            delta = this.periodValue
            this.isDeleting = true
        } else if (this.isDeleting && this.txt === '') {
            this.isDeleting = false
            this.wordIndex++
            delta = 500
        }

        setTimeout(() => this.type(), delta)
    }
}
